import Featured from './Featured';
import FeaturedItem from './Featured/FeaturedItem';
import SponsoredItem from './SponsoredItem';
import Heading from './Heading';
import SubHeading from './SubHeading';
import Wrapper from './Wrapper';
import Reviews from './Reviews';

export {
  Featured,
  Heading,
  SubHeading,
  Wrapper,
  Reviews,
  FeaturedItem,
  SponsoredItem,
};
